import React from 'react';
import HexbinMap from './HexBinMap';
import './SqmMap.css';
import SEOComponent from '../../components/SEOComponent';

function SqmMap() {
  return (
    <>

      <SEOComponent
        title={'ottaproperty.co.uk - Property prices per square meter in the UK'}
        description={'Property prices per square meter in the UK'}
        url={'https://ottaproperty.co.uk/map/sqm'}
        image={'https://ottaproperty.co.uk/trends2.webp'}
      />
    <div className="sqmparent-container">
      <div className="sqmmap-container">
        <HexbinMap />
      </div>
    </div>
    </>
  );
}

export default SqmMap;